export default __webpack_public_path__ + "static/media/Gold-Plated-Meena-Bangles.5ebdd0e6.jpg";